@if (localizationReady()) {
  <app-layout />
}

<app-global-loading-overlay />
